<mat-form-field class="mat-block mat-block_with_symbol " data-symbol="грн" [formGroup]="form">
          <input matInput npNumber
                 [formControlName]="controlName"
                 placeholder="Оголошена цінність"
                 NumberInput="true"
                 [maxValue]="maxEstimatedCost"
                 [allowFloat]="true"
                 (change)="change()"
                 [digitsAfterDot]="2">
</mat-form-field>
